/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GetOrdiniFilter = {
    Tutti: 'Tutti',
    Temporaneo: 'Temporaneo',
    Provvisorio: 'Provvisorio',
    ConfermaOrdine: 'ConfermaOrdine'
} as const;
export type GetOrdiniFilter = typeof GetOrdiniFilter[keyof typeof GetOrdiniFilter];


export function instanceOfGetOrdiniFilter(value: any): boolean {
    for (const key in GetOrdiniFilter) {
        if (Object.prototype.hasOwnProperty.call(GetOrdiniFilter, key)) {
            if (GetOrdiniFilter[key as keyof typeof GetOrdiniFilter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GetOrdiniFilterFromJSON(json: any): GetOrdiniFilter {
    return GetOrdiniFilterFromJSONTyped(json, false);
}

export function GetOrdiniFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrdiniFilter {
    return json as GetOrdiniFilter;
}

export function GetOrdiniFilterToJSON(value?: GetOrdiniFilter | null): any {
    return value as any;
}

export function GetOrdiniFilterToJSONTyped(value: any, ignoreDiscriminator: boolean): GetOrdiniFilter {
    return value as GetOrdiniFilter;
}

